export default __webpack_public_path__ + "static/media/udemynode.cd26efe9.png";